import { Component, Input } from '@angular/core';

// services
import { PolicyActionService } from '@open-portal-app/core/services/policy-action.service';
import { PolicyDocumentService } from '@open-portal-app/core/services/policy-document.service';
import { PartnerBrandService, DocumentService } from '@campfire-nx/api';

export interface IConfigInterface {
  layout?: 'default' | 'group';
  title?: string;
  status?: any;
  footnote?: string;
}

@Component({
  selector: 'app-policy-link-cards',
  templateUrl: './policy-link-cards.component.html',
  styleUrls: ['./policy-link-cards.component.scss']
})
export class PolicyLinkCardsComponent {
  @Input() data!: any;
  @Input() policy!: any;
  @Input() config?: IConfigInterface;
  intercomData = this.partnerBrandService.getAttribute('intercom', 'partner');
  isIntercomEnabled = this.intercomData?.intercomAppId;

  constructor(
    private policyDocumentService: PolicyDocumentService,
    private partnerBrandService: PartnerBrandService,
    private policyActionService: PolicyActionService,
    private documentService: DocumentService
  ) {}
  
  clickEvent(linkObject: any){
    if (linkObject.linkType === 'download') {
      if (linkObject.type === 'md') {
        const payload = {
          id: linkObject.id || ''
        }

        this.documentService.getMedicalDocument(payload, this.policy.slug).then(document => {
          this.documentService.saveFile(document, 'medical_declaration');
        });
      } else {
        this.policyDocumentService.downloadDocument(linkObject.type, this.policy);
      }
    }
    if (linkObject.linkType === 'claim') {
      this.policyActionService.claimsEvent(this.policy);
    }
  }
}
